import images from '@app/images'
import Overlay from '@app/overlay/Overlay'
import RoundedButton from '@app/ui/rounded-button/RoundedButton'
import theme from '@app/ui/theme'
import React from 'react'
import { createPortal } from 'react-dom'

import * as S from './ResetParameterConfirmationModal.styles'

interface ResetParameterConfirmationModalProps {
  showModal: boolean
  closeModal: () => void
  acceptFunction: () => void
  parameterLabel: string
  originalValue: number | string
}

export const ResetParameterConfirmationModal = ({
  showModal,
  closeModal,
  acceptFunction,
  parameterLabel,
  originalValue,
}: ResetParameterConfirmationModalProps) => {
  if (!showModal) return null

  const modalContent = (
    <Overlay closeAction={closeModal} zIndex={30000}>
      <S.MainContainer>
        <S.InnerContainer>
          <S.ImageContainer>
            <images.svg.Warning height="100%" width="100%" />
          </S.ImageContainer>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <S.EmphasizedText
              style={{
                fontSize: 24,
                fontWeight: 800,
                textAlign: 'center',
              }}
            >
              Reset {parameterLabel}?
            </S.EmphasizedText>
            <span
              style={{
                textAlign: 'center',
                marginTop: 12,
              }}
            >
              This will reset {parameterLabel} to its original value of{' '}
              <strong>{originalValue}</strong>. Are you sure you wish to continue?
            </span>
          </div>
          <div style={{ display: 'flex', width: '100%' }}>
            <RoundedButton
              style={{ flex: 3, backgroundColor: theme.colors.warning }}
              title="Yes, reset"
              textStyle={{ lineHeight: 0, textTransform: 'none' }}
              onPress={acceptFunction}
            />
            <div style={{ margin: 16, marginBottom: 0 }}></div>
            <RoundedButton
              style={{
                flex: 1,
                backgroundColor: theme.colors.white,
                border: `1px solid ${theme.colors.secondary}`,
              }}
              textStyle={{
                lineHeight: 0,
                textTransform: 'none',
                color: theme.colors.secondary,
              }}
              onPress={closeModal}
              title="Go back"
            />
          </div>
        </S.InnerContainer>
      </S.MainContainer>
    </Overlay>
  )

  return createPortal(modalContent, document.body)
}
